/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Typewriter_IntroInputs */

const en_typewriter_intro = /** @type {(inputs: Typewriter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is Sohan R. Emon`)
};

const ar_typewriter_intro = /** @type {(inputs: Typewriter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنا سوهان ر. إيمون`)
};

const bn_typewriter_intro = /** @type {(inputs: Typewriter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এটি সোহান আর. ইমন`)
};

const de_typewriter_intro = /** @type {(inputs: Typewriter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das ist Sohan R. Emon`)
};

const es_typewriter_intro = /** @type {(inputs: Typewriter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este es Sohan R. Emon`)
};

const fr_typewriter_intro = /** @type {(inputs: Typewriter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voici Sohan R. Emon`)
};

const pt_typewriter_intro = /** @type {(inputs: Typewriter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este é Sohan R. Emon`)
};

const zh_typewriter_intro = /** @type {(inputs: Typewriter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我是 Sohan R. Emon`)
};

const tr_typewriter_intro = /** @type {(inputs: Typewriter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Sohan R. Emon`)
};

const ru_typewriter_intro = /** @type {(inputs: Typewriter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это Сохан Р. Эмон.`)
};

const pl_typewriter_intro = /** @type {(inputs: Typewriter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To jest Sohan R. Emon`)
};

/**
* | output |
* | --- |
* | "This is Sohan R. Emon" |
*
* @param {Typewriter_IntroInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const typewriter_intro = /** @type {((inputs?: Typewriter_IntroInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Typewriter_IntroInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_typewriter_intro(inputs)
	if (locale === "bn") return bn_typewriter_intro(inputs)
	if (locale === "de") return de_typewriter_intro(inputs)
	if (locale === "es") return es_typewriter_intro(inputs)
	if (locale === "fr") return fr_typewriter_intro(inputs)
	if (locale === "pt") return pt_typewriter_intro(inputs)
	if (locale === "zh") return zh_typewriter_intro(inputs)
	if (locale === "tr") return tr_typewriter_intro(inputs)
	if (locale === "ru") return ru_typewriter_intro(inputs)
	if (locale === "pl") return pl_typewriter_intro(inputs)
	return en_typewriter_intro(inputs)
});